// Check if global scope is available
window.RosenheimJetzt = window.RosenheimJetzt ? window.RosenheimJetzt : []

/**
 * Controls the behaviour of '.js__search__form' - SearchResultAutoUpdate
 * @type {Window.RosenheimJetzt.SearchResultAutoUpdate}
 */
window.RosenheimJetzt.SearchResultAutoUpdate = class SearchResultAutoUpdate {
	/**
	 * constructor
	 * @param dom
	 * @returns {void}
	 */
	constructor(dom) {
		this.dom = dom
		this.state = {
			autoFormSubmitIsActive: false,
			isAvailableOnViewport: false,
			viewport: 1200,
		}

		this.selectors = {
			inputElementClass: 'js__search-filters__input',
			searchChipsWrapper: 'js__search-chips',
			searchChip: 'js__search-chips__chip',
		}

		this.bindEvents()
		this.toggleOffCanvasFilterSidebar()
	}

	/**
	 * bindEvents
	 * @returns {void}
	 */
	bindEvents() {
		this.state.isAvailableOnViewport = window.innerWidth >= 1200
		// Windows resize
		window.onresize = (event) => {
			this.state.isAvailableOnViewport = window.innerWidth >= 1200 ? true : false
		}

		this.dom.onclick = (event) => {
			// Stop event bubbling to parent elements, to prevent side effects for the future scaling.
			event.stopPropagation()
			var target = event.target

			if (
				target.classList.contains(this.selectors.inputElementClass) &&
				this.state.isAvailableOnViewport &&
				this.state.autoFormSubmitIsActive === false
			) {
				this.submitForm()
			}
		}
	}

	/**
	 * submitForm
	 * @returns {void}
	 */
	submitForm() {
		this.dom.submit()
		this.state.autoFormSubmitIsActive = true
	}

	/**
	 * toggleOffCanvasFilterSidebar
	 * @returns {void}
	 */
	toggleOffCanvasFilterSidebar() {
		var searchChipsWrapperElement = document.querySelector('.' + this.selectors.searchChipsWrapper)
		if (searchChipsWrapperElement) {
			searchChipsWrapperElement.onclick = (event) => {
				// Stop event bubbling to parent elements, to prevent side effects for the future scaling.
				event.stopPropagation()
				var target = event.target
				// Only below 1200px viewport
				if (target.classList.contains(this.selectors.searchChip) && !this.state.isAvailableOnViewport) {
					document.body.classList.toggle('filters-are-visible')
				}
			}
		}
	}
}
